import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Heading({primary = false, secondary = false, modal = false, children}) {
  return (
    <div
      className={classnames('heading', {
        '-primary': primary,
        '-secondary': secondary,
        '-modal': modal,
      })}>
      {children}
    </div>
  );
}

Heading.propTypes = {
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  modal: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default Heading;
